import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54b8ae72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "w-full tablet:px-[5%] py-5"
}
const _hoisted_2 = { class: "text-orange font-bold p-5 text-2xl" }
const _hoisted_3 = { class: "flex flex-col items-start text-left" }
const _hoisted_4 = { class: "text-green font-semibold mb-2 ml-2" }
const _hoisted_5 = { class: "bg-gray-100 rounded-md" }
const _hoisted_6 = { class: "w-[120px] font-medium" }
const _hoisted_7 = { class: "w-[calc(100%-120px)]" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = ["href"]

import {defineProps, withDefaults} from "vue/dist/vue";
import {Competition} from "@/interfaces/interfaces";


export default /*#__PURE__*/_defineComponent({
  props: {
    year: null,
    events: null
  },
  setup(__props: any) {

const props = __props as { year: number, events: Competition[] }



function getUsedMonths(){
  let usedMonths : string[] = []
  props.events.forEach((item) => {
    let month = getMontNumberFromDate(item.date)
    if(!usedMonths.includes(month))
      usedMonths.push(month)
  })
  return usedMonths
}

function getMontNumberFromDate(date : string): string {
  return date.split('.')[date.split('.').length-2] as string
}

function getMonthName(monthString: string){
  switch (monthString){
    case '1' : return 'Leden'
    case '2' : return 'Únor'
    case '3' : return 'Březen'
    case '4' : return 'Duben'
    case '5' : return 'Květen'
    case '6' : return 'Červen'
    case '7' : return 'Červenec'
    case '8' : return 'Srpen'
    case '9' : return 'Září'
    case '10' : return 'Říjen'
    case '11' : return 'Listopad'
    case '12' : return 'Prosinec'
  }
}

function getMontEvents(month: string){
  return props.events.filter((item) => getMontNumberFromDate(item.date) === month).sort(compareEvents)
}

function compareEvents(a: Competition, b: Competition){
  if(a.date.split('.')[0].length > b.date.split('.')[0].length){
    return 1
  }
  else if (a.date.split('.')[0].length < b.date.split('.')[0].length){
    return -1
  }
  else {
    return 0
  }
}


return (_ctx: any,_cache: any) => {
  return (__props.events.length !== 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.year), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUsedMonths(), (month) => {
            return (_openBlock(), _createElementBlock("div", {
              key: month,
              class: "p-3 w-full"
            }, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(getMonthName(month) + ' ' + __props.year), 1),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMontEvents(month), (event) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: event,
                    class: "flex flex-row items-start px-5 laptop:px-10 p-2 w-[100%] text-greenDarkest"
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(event.date), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(event.name), 1),
                      (event.results)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: '/PDFs/vysledky/' + event.results,
                            target: "_blank",
                            class: "text-green text-sm font-semibold underline pl-3"
                          }, " výsledky ", 8, _hoisted_9))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})